import { render } from "./OcrFolderPanel.vue?vue&type=template&id=50ab2b7a"
import script from "./OcrFolderPanel.vue?vue&type=script&lang=js"
export * from "./OcrFolderPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__